export const VISA_STATUSES = ['new', 'processing', 'error', 'finalize'];

export const DEFAULT_VISA_STATUS = 'new';

export const MANAGER_UPDATABLE_STATUSES = ['error', 'finalize'];

export const formatStatusLabel = (status) => {
  const normalized = status || DEFAULT_VISA_STATUS;
  if (normalized === 'finalize') return 'Finalized';
  return normalized.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'processing':
      return 'bg-yellow-100 text-yellow-700';
    case 'finalize':
      return 'bg-green-100 text-green-700';
    case 'error':
      return 'bg-red-100 text-red-700';
    case 'new':
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export const STATUS_FILTER_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'processing', label: 'Processing' },
  { value: 'error', label: 'Error' },
  { value: 'finalize', label: 'Finalized' },
];

export const STATUS_CHART_COLORS = {
  new: '#9CA3AF',
  processing: '#F59E0B',
  error: '#EF4444',
  finalize: '#10B981',
};
